import { Box, Chip } from '@coolblue-development/becky';
import { Attachment } from '../../../../../../models/Attachment';
import CloseIcon from '../../../../Icons/CloseIcon';

interface AttachmentChipsProps {
  attachments: Attachment[];
  onRemove: (attachmentId: string) => void;
}

const AttachmentChips = ({ attachments, onRemove }: AttachmentChipsProps): JSX.Element | null => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '12px'
      }}
      data-testid="attachment-chips-container"
    >
      {attachments.map(attachment => (
        <Chip
          key={attachment.id}
          label={attachment.name}
          onDelete={() => onRemove(attachment.id)}
          deleteIcon={<CloseIcon data-testid={`attachment-chip-delete-${attachment.id}`} />}
          size="small"
          data-testid={`attachment-chip-${attachment.id}`}
        />
      ))}
    </Box>
  );
};

export default AttachmentChips;
